import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { getUserTags } from '~~/src/api/tags'
import type { GetReturn } from '~~/src/types/utils'

export const useTagsQuery = (
  args: {
    userId?: MaybeRef<string | null | undefined>
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getUserTags>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getUserTags>, Error> => {
  return useQuery({
    queryKey: ['user-tags', args.userId] as const,
    queryFn: async ({ queryKey }) => {
      const [_, userId] = queryKey
      if (!userId)
        return []
      return await getUserTags(userId)
    },
    ...options,
  })
}
